import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import Select, { ISelectValueType } from 'src/components/form-components/Select/Select';
import { Bone } from 'src/components/Placeholder/Placeholder';

export interface IPersonCountProps {
    count: number;
    maxCount: number;
    onChange: (personCount: number) => void;
    shouldHideText?: boolean;
    showSingleOption?: boolean;
    className?: string;
}

const messages = defineMessages({
    forNPeople: {
        id: 'forNPeople',
        defaultMessage: 'főre'
    }
});


const generateOptions = (maxPersonCount: number): ISelectValueType[] =>
    Array.from(Array(maxPersonCount), (e, i) => (
        {
            value: String(i + 1),
            label: String(i + 1)
        }));

const PersonCount: React.FunctionComponent<IPersonCountProps> = ({ maxCount, count, onChange, shouldHideText, showSingleOption, className = '' }) => {

    const handlePersonCountChange = (value: string) => {
        onChange(+value)
    }

    const dropdown =
        <Select
            className="person-count__select"
            values={generateOptions(maxCount)}
            value={count}
            onChange={handlePersonCountChange}
        />

    if (maxCount <= 1 && !showSingleOption) { return null; }

    return (
        <div className={'person-count ' + className}>
            {dropdown}
            {!shouldHideText &&
                <span className='person-count__text'>
                    <FormattedMessage {...messages.forNPeople} values={{ n: count }} />
                </span>
            }
        </div>
    )
}

export const PersonCountSkeleton = () => <Bone className="person-count__select" />

export default PersonCount;